export function loadState(name) {
  try {
    const serializedState = localStorage.getItem(name)
    if (serializedState) {
      return JSON.parse(serializedState)
    }
  } catch (err) {
    // Do nothing
  }
  return undefined
}

export function saveState(name, state) {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem(name, serializedState)
  } catch (err) {
    // Do nothing
  }
}

export function removeState(name) {
  try {
    localStorage.removeItem(name)
  } catch (err) {
    // Do nothing
  }
}
